import { useLocation } from 'react-router';
import { LANGUAGE_DEFINITIONS } from '@@/languageConfig';



export const Hreflang = () => {
	const { pathname } = useLocation();

	return (
		<>
			<link
				rel="alternate"
				href={`https://${LANGUAGE_DEFINITIONS['CZ'].websiteDomain}${pathname}`}
				hrefLang="x-default"
			/>
			
			{Object.entries(LANGUAGE_DEFINITIONS).map(([language, definition]) => (
				<link
					key={language}
					rel="alternate"
					href={`https://${definition.websiteDomain}${pathname}`}
					hrefLang={definition.isoLanguageCode}
				/>
			))}
		</>
	);
};